<nav class="navbar-header">
  <app-context-current></app-context-current>
  <div class="flex-spacer"></div>

  <!-- User menu -->
  <div ngbDropdown>
    <button class="btn btn-outline" id="dropdownForm1" ngbDropdownToggle>
      <span class="d-sm-inline">{{ (user$ | async).name }}</span>
    </button>
    <div ngbDropdownMenu>
      <div class="dropdown-header d-xs-block d-sm-none">{{ (user$ | async).name }}</div>
      <button (click)="openPasswordModal()" ngbDropdownItem aria-label="Change password">Change Password</button>
      <button (click)="openProfileModal()" ngbDropdownItem aria-label="Update profile">Update Profile</button>
      <div class="dropdown-divider"></div>
      <button ngbDropdownItem aria-label="Admin settings" (click)="viewAdminSettings()">Admin Settings</button>
      <button ngbDropdownItem aria-label="Personal settings" (click)="viewPersonalSettings()">Personal Settings</button>
      <div class="dropdown-divider"></div>
      <button ngbDropdownItem aria-label="Support">Support</button>
      <button (click)="logout()" ngbDropdownItem aria-label="Log out">Log Out</button>
    </div>
  </div>
</nav>
<ngb-progressbar type="primary" [value]="100" [animated]="true" [striped]="true" *ngIf="loadingStatusService.loading$ | async" title="Loading page..."></ngb-progressbar>
